import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { Modal, ProductMultiSelect } from './ui.jsx';
import { stages } from '../data.js';

// Shared create/edit modal for an opportunity (Deal). Pass `account` to lock
// the account (used when adding a deal from within an account's detail view);
// omit it to let the user pick/change the account (used for editing a deal
// from the pipeline list or the deal detail page).
export default function DealModal({ deal, account, accounts = [], contacts = [], team = [], products = [], onClose, onSave }) {
  const editing = Boolean(deal);
  const [form, setForm] = useState({
    accountId: deal?.accountId || account?.id || accounts[0]?.id || '',
    contact: deal?.contact || '',
    products: deal?.products?.length ? deal.products : (products[0] ? [products[0].name] : []),
    value: deal?.value ?? '',
    stage: deal?.stage || 'Proposal',
    close: deal?.close || '',
    owner: deal?.owner || account?.owner || team[0]?.id || '',
    probability: deal?.probability ?? 65,
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const selectedAccount = account || accounts.find((a) => a.id === form.accountId);
  const accountContacts = contacts.filter((c) => c.accountId === form.accountId);

  return (
    <Modal
      title={editing ? 'Edit opportunity' : `Add deal${selectedAccount ? ` for ${selectedAccount.name}` : ''}`}
      subtitle="Track a specific opportunity tied to this account."
      onClose={onClose}
      actions={<><button className="btn btn-ghost" onClick={onClose}>Cancel</button><button className="btn btn-primary" onClick={() => onSave(form)}><Save size={14} />{editing ? 'Save changes' : 'Add deal'}</button></>}
    >
      {!account && (
        <label>Account<select value={form.accountId} onChange={set('accountId')}>{accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></label>
      )}
      <label>Contact<input list="deal-modal-contacts" placeholder="Full name" value={form.contact} onChange={set('contact')} /></label>
      <datalist id="deal-modal-contacts">{accountContacts.map((c) => <option key={c.id} value={c.name} />)}</datalist>
      <label>Products<ProductMultiSelect value={form.products} options={products.map((p) => p.name)} onChange={(v) => setForm({ ...form, products: v })} /></label>
      <div className="modal-form-row">
        <label>Deal value<input type="number" min="0" placeholder="0" value={form.value} onChange={set('value')} /></label>
        <label>Stage<select value={form.stage} onChange={set('stage')}>{stages.map((s) => <option key={s}>{s}</option>)}</select></label>
      </div>
      <div className="modal-form-row">
        <label>Expected close date<input type="date" value={form.close} onChange={set('close')} /></label>
        <label>Owner<select value={form.owner} onChange={set('owner')}>{team.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}</select></label>
      </div>
      <label>Win probability ({form.probability}%)<input type="range" min="0" max="100" value={form.probability} onChange={set('probability')} /></label>
    </Modal>
  );
}
